import Immutable from 'immutable';

import ClassFactory from 'sharedreact/utils/ClassFactory';

const Content: {
  objType: string,
  id: string,
  todoId: string,
  type: string,
  position: number,
  name: string,
  value: string,
  prompt: string,
  info: string,
  style: string,
  placeholder: string,
  displayText: string,
  checkBoxOnValue: string,
  checkBoxOffValue: string,
  values: Immutable.List<string> | null,
} = {
  objType: 'ToDoParameter',
  id: '',
  todoId: '',
  type: '',
  position: 0,
  name: '',
  value: '',
  prompt: '',
  info: '',
  style: '',
  placeholder: '',
  displayText: '',
  checkBoxOnValue: '',
  checkBoxOffValue: '',
  values: null
};

class ToDoParameter extends Immutable.Record(Content) {
  static fromJS (json: object): ToDoParameter {
    return ClassFactory.createFromJson(json, ToDoParameter);
  }
}

export default ToDoParameter;
